export enum EventPoints {
  ORDER_CREATE = 'order/create',
  ORDERS_GET = 'orders/get',
  PATCH_HIDE_ORDER = 'order/hide',
}



// WEBPACK FOOTER //
// ./src/services/orders/types.ts